import React, { useState, useEffect, useMemo } from "react";
import StreakFlame from "./Streak";
import { safeApiCall } from "../utils/safeApiCall";
import { data } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Ranking( { rankingService, streakService, color, finished , userUpdate }) {
    const [ranking, setRanking] = useState(Array(10).fill({ username: "-", score: 0 }));
    const [streak, setStreak] = useState(0);
    const { isLoggedIn, contextUser } = useAuth();
    const flameColors = useMemo(() => {
        switch(color){
            case "red":
                return [180, 0, 0];
            case "neon-violet":
                return [128, 0, 128];
            default:
                return [180, 0, 0];
        }
    }, []);


    useEffect(() => {
        const fetchRanking = async () => {
            const response = await safeApiCall(rankingService, {data: []});
            if (response.data.length < 10) {
                setRanking([...response.data, ...Array(10 - response.data.length).fill({ username: "-", score: 0 })]);
            } else {
                setRanking(response.data);
            }
        };
        const fetchStreak = async () => {
            const response = await safeApiCall(streakService, {data: {streak: 0, last_played: "2012-12-12"}});
            setStreak(response.data.streak);

        };
        if (contextUser) {
            if (isLoggedIn) {
                fetchRanking();
            } else {
                setRanking(Array(10).fill({ username: "-", score: 0 }));
            }
            fetchStreak();
        }
    }, [contextUser]);

    useEffect(() => {
        if (finished && userUpdate.current) {
            setStreak(prev => prev + 1);
        }
    }, [finished]);

    const mapRanking = (ranking) => {
        return ranking.map((row, index) => (
            <React.Fragment key={index}>
                <span className="ranking-name">{row.username}</span>
                <span className="ranking-score">{row.score}</span>
            </React.Fragment>
        ));
    }
    
    return (
        <div className={`ranking-container ranking-border-${color}`}>
            <h2>Top Players</h2>
            <div className={`ranking-list ${isLoggedIn ? "" : "ranking-blur"}`}>
                <span className="ranking-header-name">Username</span>
                <span className="ranking-header-score">Score</span>
                {mapRanking(ranking)}
            </div>
            <h3 className="streak">Your current streak:</h3>
            <StreakFlame streak={streak} size={100} active={finished} color={flameColors} />
        </div>
    );

}